import React, { useEffect, useState } from "react";
import style from "./Job.module.css";
import compProfile from "../../../Assets/compProfile.svg";
import money from "../../../Assets/salary_icon.svg";
import map from "../../../Assets/location.svg";
import award from "../../../Assets/award2.svg";
import people from "../../../Assets/people.svg";
import monitor from "../../../Assets/monitor.svg";
import dot from "Assets/dot.svg";
import axios from "axios";
import Readmore from "../Readmore/Readmore";
// import Button from "../Button/Button";
import Save from "../SaveBtn/Save";
import { useDispatch, useSelector } from "react-redux";
import { postActions } from "../../../redux/actions";
import * as api from "../../../services/api";
import { useLocation } from "react-router-dom";
import { Box } from "@chakra-ui/layout";
import { color } from "style-value-types";
import { useWindow } from "hooks/useWindow";
import Moment from "react-moment";
import { Button, Flex } from "@chakra-ui/react";
import { myApplicationFactory } from "helper/factory";
import Swal from "sweetalert2";
import { Login, sendNotification } from "helper/notification";
import { AcceptReject } from "helper/defaultMessage";

const JobCard = ({
  buttonContent,
  saveBtn,
  post,
  setStatus,
  setInviteId,
  setInvites,
  inviteId,
  setPostID,
  appliedData,
  postID,
  setMobileView,
}) => {
  const levels = [
    "Foundation",
    "3D NFT Creator",
    "3D Environment Creator",
    "XR Interaction Creator",
    "Simulation Creator",
    "Ajna Creator",
  ];
  const location = useLocation();
  const windowSize = useWindow();

  const [profileData, setProfileData] = useState();
  const [alreadyApplied, setAlreadyApplied] = useState(false);
  const [buttonTexts, setButtonTexts] = useState([]);
  const [tab, setTab] = useState("");
  const user = JSON.parse(localStorage.getItem("user"));
  const applications = useSelector((state) => state.application.data);
  const invites = useSelector((state) => state.invite.data);
  const { navbarToggle } = useSelector((state) => state.student);
  const dispatch = useDispatch();
  const locationArr = location.pathname.split("/");
  const locationEndpoint = locationArr[locationArr.length - 1];
  const { accepted } = useSelector((state) => state.post);

  useEffect(() => {
    if (location) {
      if (locationEndpoint === "findjob") {
        setTab("findjob");
        // setButtonTexts(["Apply", "Applied"]);
        const apps = applications?.filter(
          (item) => item?.hiringPostId?._id === post?._id
        );
        // console.log({ applications }, post);
        if (apps.length > 0) {
          setButtonTexts("Applied");
        } else {
          setButtonTexts("Apply");
        }
      } else if (locationEndpoint === "myapplication") {
        setTab("myapplication");
        const apps = applications?.filter(
          (item) => item?.hiringPostId?._id === post?.hiringPostId?._id
        );
        if (apps.length > 0) {
          if (apps[0].status === "inTouch") {
            setButtonTexts("In Touch");
          } else if (apps[0].status === "hired") {
            setButtonTexts("Hired");
          } else if (apps[0].status === "rejected") {
            setButtonTexts("Rejected");
          }
        }
      } else if (locationEndpoint === "invites") {
        setTab("invites");
        const inv = invites?.filter(
          (item) => item?.hiringPostId?._id === post?.hiringPostId?._id
        );
        if (inv.length > 0) {
          if (inv[0].status === "accepted") {
            setButtonTexts("Accepted");
          } else if (inv[0].status === "rejected") {
            setButtonTexts("Rejected");
          } else {
            setButtonTexts("Accept");
          }
        }
        // setButtonTexts(['Accept', 'Accepted']);
      }
    }
  }, [location, applications]);

  const applyFn = async () => {
    const response = await api.applyToJob(post._id);
    if (response.status === 200) {
      setAlreadyApplied(true);
      setButtonTexts("Applied");
    }
  };

  const acceptFn = async (inviteId, status) => {
    try {
      if (status === "rejected") {
        Swal.fire({
          icon: "warning",
          title: "Are you sure?",
          text: "You want to reject this invite?",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        })
          .then(async (result) => {
            if (result.isConfirmed) {
              const response = await api.changeStatusOfInvite(inviteId, status);
              if (response.status === 200) {
                const { data } = await api.getAllInvitesForStudent();
                const modifiedData = data?.data?.data.map((item) => {
                  return myApplicationFactory(
                    item?.hiringPostId,
                    item?.status,
                    item?._id
                  );
                });
                setInvites(modifiedData);
                setPostID("");
                dispatch(postActions?.acceptJob());
                setButtonTexts("Rejected");
                Login({
                  name: response?.data?.data?.invitedBy?.name,
                  room: response?.data?.data?.invitedBy?._id,
                });
                sendNotification({
                  room: response?.data?.data?.invitedBy?._id,
                  username: response?.data?.data?.invitedBy?.name,
                  message: AcceptReject(
                    user.name,
                    "rejected",
                    response?.data?.data?.hiringPostId?.jobRoleTitle
                  ),
                });
              }
            }
            return;
          })
          .catch((err) => {
            console.log(err);
          });
      }
      if (status === "accepted") {
        const response = await api.changeStatusOfInvite(inviteId, status);
        if (response.status === 200) {
          const { data } = await api.getAllInvitesForStudent();
          const modifiedData = data?.data?.data.map((item) => {
            return myApplicationFactory(
              item?.hiringPostId,
              item?.status,
              item?._id
            );
          });
          Login({
            name: response?.data?.data?.invitedBy?.name,
            room: response?.data?.data?.invitedBy?._id,
          });
          sendNotification({
            room: response?.data?.data?.invitedBy?._id,
            username: response?.data?.data?.invitedBy?.name,
            message: AcceptReject(
              user.name,
              "accepted",
              response?.data?.data?.hiringPostId?.jobRoleTitle
            ),
          });
          setInvites(modifiedData);
          setPostID("");
          dispatch(postActions?.acceptJob());
          setButtonTexts("Accepted");
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div
      onClick={() => {
        setPostID(post._id);
        setStatus(post?.jobStatus);
        setInviteId(post?.inviteId);
        windowSize < 480 && setMobileView(true);
      }}
      className={style.container}
      style={{
        zIndex: navbarToggle ? "-1" : 0,
        marginRight: "10px",
        border: postID
          ? postID === post._id
            ? "1px solid #9A9A9A"
            : "1px solid #E7E6E8"
          : "1px solid #E7E6E8",
      }}
    >
      {
        <>
          {/* profilecontainer with Apply&saveIcon btn */}

          <div className={style.profileApplyBtnCont}>
            <div className={style.leftCont}>
              <div className={style.compProfile}>
                <img
                  src={
                    post?.companyID?.profilePhoto ||
                    post?.hiringPostId?.companyID?.profilePhoto
                  }
                  alt=""
                  onError={(e) => {
                    return (e.target.src = "https://via.placeholder.com/150");
                  }}
                />
              </div>
              <div className={style.joroleCompName}>
                <div className={style.jobrole}>
                  {post.jobRoleTitle || post?.hiringPostId?.jobRoleTitle}
                </div>
                <div className={style.compName}>
                  {post?.companyID?.companyName ||
                    post?.hiringPostId?.companyID?.companyName}
                </div>
              </div>
            </div>
            {/* button */}

            {/* <div className={style.rightCont}>
              {tab === "findjob" && (
                <Button
                  buttonContent={buttonTexts}
                  clickHandler={applyFn}
                  isDisabled={buttonTexts === "Applied"}
                />
              )}
              {tab === "myapplication" && (
                // <Button isDisabled={true} buttonContent={buttonTexts} style={{color:"red"}} />
                <Box
                  border="1px solid"
                  px={[15, 5, 5, 4]}
                  w={["100%", "100%", "fit-content", "fit-content"]}
                  py={2}
                  borderRadius={40}
                  display={["block", "block", "block", "block"]}
                  bg={
                    (buttonTexts == "In Touch" && "rgba(255, 206, 1, 0.1)") ||
                    (buttonTexts == "Hired" && "#rgba(0, 212, 174, 0.1)") ||
                    (buttonTexts == "Rejected" && "rgba(255, 89, 94, 0.11)")
                  }
                  color={
                    (buttonTexts == "In Touch" && "#FFCE01") ||
                    (buttonTexts == "Hired" && "#00D4AE") ||
                    (buttonTexts == "Rejected" && "#FF595E")
                  }
                >
                  {buttonTexts}
                </Box>
              )}
              {tab === "invites" &&
                (buttonTexts === "Accept" ? (
                  <Button buttonContent={buttonTexts} clickHandler={acceptFn} />
                ) : (
                  <Button buttonContent={buttonTexts} isDisabled={true} />
                ))}
            </div> */}
          </div>

          {/* salary &location */}
          <div className={style.salaryLocation}>
            <div className={style.salaryCont}>
              <div className={style.money}>
                <img src={money} alt="" />
              </div>
              <div className={style.salaryLpa}>
                <p className={style.salaryTxt}>Salary -</p>
                <p className={style.package}>
                  {post?.packageOffered || post?.hiringPostId?.packageOffered}{" "}
                  LPA
                </p>
              </div>
            </div>
            <span>
              <img src={dot} alt="dot" />
            </span>
            {/* location */}
            <div className={style.salaryCont}>
              <div className={style.money}>
                <img src={map} alt="" />
              </div>
              <div className={style.salaryLpa}>
                <p className={style.salaryTxt}>Location -</p>
                <p className={style.package}>
                  {post?.location || post?.hiringPostId?.location}
                </p>
              </div>
            </div>
          </div>
          <div className={style.salaryLocation}>
            <div className={style.salaryCont}>
              <div className={style.money}>
                <img src={monitor} alt="" />
              </div>
              <div className={style.salaryLpa}>
                <p className={style.salaryTxt}>Platform -</p>
                <p className={style.package}>
                  {post?.platform || post?.hiringPostId?.platform}
                </p>
              </div>
            </div>
            <span>
              <img src={dot} alt="dot" />
            </span>
            {/* location */}
            <div className={style.salaryCont}>
              <div className={style.money}>
                <img src={people} alt="" />
              </div>
              <div className={style.salaryLpa}>
                <p className={style.salaryTxt}>Openings -</p>
                <p className={style.package}>
                  {post?.openings || post?.hiringPostId?.openings}
                </p>
              </div>
            </div>
          </div>
          {/* badges */}
          <div className={style.badgesCon}>
            <div className={style.badges}>
              <div className={style.nftCont}>
                <img src={award} alt="" />
              </div>
              <button
                className={style.badgeTitle}
                style={{
                  fontFamily: "Roboto",
                  fontWeight: "500",
                  cursor: "default",
                }}
              >
                {levels[post?.requiredLevel] ||
                  levels[post?.hiringPostId?.requiredLevel]}
              </button>
            </div>
          </div>

          {/*jobposted data */}
          <div className={style.jobpostedCont}>
            <div className={style.dates}>
              <p className={style.datesText}>
                Posted on: <Moment format="DD-MM-YYYY">{post.createdAt}</Moment>
              </p>
            </div>
            <div className={style.dates}>
              <p className={style.datesText}>
                Apply By:{" "}
                <Moment format="DD-MM-YYYY">
                  {post?.applyByDate || post?.hiringPostId?.applyByDate}
                </Moment>
              </p>
            </div>
          </div>

          {windowSize > 500 && locationEndpoint == "invites" && (
            <>
              {post?.status !== "accepted" && (
                <Flex justify={"space-between"} my={4}>
                  <Button
                    w={"45%"}
                    justify={"center"}
                    align={"center"}
                    py={"6px"}
                    borderRadius={8}
                    fontFamily={"Roboto"}
                    fontWeight={500}
                    fontSize={16}
                    onClick={() => acceptFn(post?.inviteId, "rejected")}
                    border={"1px solid #CECCD1"}
                  >
                    Not Interested
                  </Button>

                  <Button
                    w={"45%"}
                    justify={"center"}
                    align={"center"}
                    py={"6px"}
                    borderRadius={8}
                    fontFamily={"Roboto"}
                    fontWeight={500}
                    fontSize={16}
                    border={"1px solid #CECCD1"}
                    bg="#6C56FB"
                    _hover={{ bg: "#9748ff" }}
                    color={"#fff"}
                    onClick={() => acceptFn(post?.inviteId, "accepted")}
                  >
                    Accept
                  </Button>
                </Flex>
              )}
            </>
          )}

          {/* job desc */}
          {/* <div className={style.jobdescCont}>
            <div className={style.jobdescTxt}>Job Description</div>
            <Readmore className={style.desc}
            id={post._id}
            >
              {post?.jobDescription || post?.hiringPostId?.jobDescription}
            </Readmore>
          </div> */}
        </>
      }
    </div>
  );
};

export default JobCard;
